export class NiceScale {
    private minPoint = 0;
    private maxPoint = 0;
    private maxTicks = 10;
    private tickSpacing = 0;
    private range = 0;
    private niceMin = 0;
    private niceMax = 0;

    /// <summary>
    /// Initializes a new instance of the <see cref="NiceScale"/> class.
    /// </summary>
    /// <param name="min">The minimum data point on the axis.</param>
    /// <param name="max">The maximum.</param>
    constructor(min: number, max: number) {
        this.minPoint = min;
        this.maxPoint = max;
        this.calculate();
    }

    /// <summary>
    /// Calculate and update values for tick spacing and nice
    /// minimum and maximum data points on the axis.
    /// </summary>
    private calculate() {
        this.range = this.niceNum(this.maxPoint - this.minPoint, false);
        this.tickSpacing = this.niceNum(this.range / (this.maxTicks - 1), true);
        this.niceMin = Math.floor(this.minPoint / this.tickSpacing) * this.tickSpacing;
        this.niceMax = Math.ceil(this.maxPoint / this.tickSpacing) * this.tickSpacing;
    }

    /// <summary>
    /// Returns a "nice" number approximately equal to range Rounds the number if round = true Takes the ceiling if round = false.
    /// </summary>
    /// <param name="range">The range.</param>
    /// <param name="round">Whether to round the result</param>
    /// <returns></returns>
    private niceNum(range: number, round: boolean) {
        let exponent = 0; /** exponent of range */
        let fraction = 0; /** fractional part of range */
        let niceFraction = 0; /** nice, rounded fraction */

        exponent = Math.floor(Math.log10(range));
        fraction = range / Math.pow(10, exponent);

        if (round) {
            if (fraction < 1.5)
                niceFraction = 1;
            else if (fraction < 3)
                niceFraction = 2;
            else if (fraction < 7)
                niceFraction = 5;
            else
                niceFraction = 10;
        }
        else {
            if (fraction <= 1)
                niceFraction = 1;
            else if (fraction <= 2)
                niceFraction = 2;
            else if (fraction <= 5)
                niceFraction = 5;
            else
                niceFraction = 10;
        }

        return niceFraction * Math.pow(10, exponent);
    }

    /// <summary>
    /// Sets the minimum and maximum points for the axis.
    /// </summary>
    /// <param name="minPoint">The minimum point.</param>
    /// <param name="maxPoint">The maximum point.</param>
    public setMinMaxPoints(minPoint: number, maxPoint: number) {
        this.minPoint = minPoint;
        this.maxPoint = maxPoint;
        this.calculate();
    }

    /// <summary>
    /// Sets the maximum ticks we're comfortable with.
    /// </summary>
    /// <param name="maxTicks">The maximum ticks.</param>
    public setMaxTicks(maxTicks: number) {
        this.maxTicks = maxTicks;
        this.calculate();
    }

    /// <summary>
    /// Gets the tick spacing.
    /// </summary>
    /// <returns></returns>
    public getTickSpacing(): number {
        return this.tickSpacing;
    }

    /// <summary>
    /// Gets the "nice" minimum data point.
    /// </summary>
    /// <returns></returns>
    public getNiceMin(): number {
        return this.niceMin;
    }

    /// <summary>
    /// Gets the "nice" maximum data point.
    /// </summary>
    /// <returns></returns>
    public getNiceMax(): number {
        return this.niceMax;
    }
}